import React, { useEffect } from 'react';
import { SingleDatePicker } from '@sede-enterprise/shell-ds-react-framework';
import moment, { Moment } from 'moment-timezone';
import { getAuctionTimezone } from '../../core';
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import { useAppDispatch } from '../../store';
import { FetchAuctionDataOnlyAction } from '../../store';
import './Calendar.css';

export interface IDefaultCalendarProps{
    placeholder?: any;    
    day?:any;
    setDay?:any;  
}

const Calendar: React.FC<IDefaultCalendarProps> = (props) =>
{ 

    useEffect(()=>{
        const calendarElement = document.getElementsByClassName('calendar-container')[0];
        const inputElement = calendarElement.querySelector('input');
        if(inputElement){
            inputElement.disabled=true;
        }
    },[])

    const dispatch = useAppDispatch();
    return (
        <div className='calendar-container' data-testid="Calendar">
            <SingleDatePicker<Moment> 
                value={moment(props.day).tz(getAuctionTimezone())} 
                generateConfig={momentGenerateConfig}
                config='custom'
                placeholder={props.placeholder}
                onChange={(e:any) =>{
                props.setDay(e);
                const why = e.utc().format();
                dispatch(FetchAuctionDataOnlyAction(new Date(why)));
                }}
                disabledDate={(value:Moment)=>value.isAfter(moment().tz(getAuctionTimezone()),"day")}
                allowClear={false}
                showToday={false}
                />
        </div>
    );
};

export default Calendar;
